import payairEcomWrapperSdk from "@payair/e-com-wrapper-sdk"
import {
  EcomWrapperApplePayIsReadyToPayParams,
  EcomWrapperGooglePayIsReadyToPayParams,
  EcomWrapperSrciIsReadyToPayParams,
  IsReadyToPayParams,
} from "@payair/e-com-wrapper-sdk/models/IsReadyToPayParams"

const ecomWrapperApplePayIsReadyToPayParams: EcomWrapperApplePayIsReadyToPayParams = {
  ecomWalletSdkEnum: "PAYAIR_APPLE_PAY_SDK",
}

const ecomWrapperGooglePayIsReadyToPayParams: EcomWrapperGooglePayIsReadyToPayParams = {
  ecomWalletSdkEnum: "PAYAIR_GOOGLE_PAY_SDK",
}
const ecomWrapperSrciIsReadyToPayParams: EcomWrapperSrciIsReadyToPayParams = {
  ecomWalletSdkEnum: "PAYAIR_SRCI_SDK",
}

const isReadyToPayParamsArray: IsReadyToPayParams[] = [
  ecomWrapperApplePayIsReadyToPayParams,
  ecomWrapperGooglePayIsReadyToPayParams,
  ecomWrapperSrciIsReadyToPayParams,
]

const getReadyToPayWallets = () => payairEcomWrapperSdk.ecomWrapperSdk.getReadyToPayWallets(isReadyToPayParamsArray)

export default getReadyToPayWallets
